'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toHumanTime = exports.fmtSecond = exports.toTimestamp = exports.now = undefined;

var _dayjs = require('dayjs');

var _dayjs2 = _interopRequireDefault(_dayjs);

require('dayjs/locale/zh-cn');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_dayjs2.default.locale('zh-cn');

var now = exports.now = function now() {
  var fmt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'YYYY-MM-DD';

  return (0, _dayjs2.default)().format(fmt);
};

// 秒
var toTimestamp = exports.toTimestamp = function toTimestamp(t, fmt) {
  return (0, _dayjs2.default)(t, fmt).unix() || 0;
};

var fmtSecond = exports.fmtSecond = function fmtSecond(sec) {
  var m = (sec / 60 | 0) % 60;
  var s = sec % 60 | 0;

  return [m, s].join(':').replace(/\b(\d)\b/g, '0$1');
};

/**
 *  - 3天前 12:24
 */
var toHumanTime = exports.toHumanTime = function toHumanTime(time) {
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MM月DD日 a hh:mm';

  if (!time) {
    return '未知';
  }

  var format = function format(t) {
    if (String(t).length === 10) {
      return t * 1000;
    }

    return t;
  };

  if (fmt === 'fromnow') {
    return (0, _dayjs2.default)(format(time)).fromNow();
  }

  return (0, _dayjs2.default)(format(time)).format(fmt);
};